import gql from 'graphql-tag';

export default gql`
    mutation AssignDriverToLoadAndSaveLoad($input: AssignDriverAndSaveLoadListEdit) {
        assignDriverToLoadAndSaveLoad(input: $input) {
            errors
            loadIds
        }
    }
`;
